import { IconKey,IconBuildingSkyscraper } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconBuildingSkyscraper
};
//

const Corporate = {

    id: 'corporate',
    title: 'Corporate',
    type: 'group',
    display_id:'K',
    icon: icons.IconBuildingSkyscraper,
    children: [
        {
            id: 'corporate_dashboard',
            title: 'Dashboard',
            type: 'item',
            display_id:45,
            url: '/Department/Corporate',
            breadcrumbs: false
        },
    ]
}

export default Corporate;